import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfApartments } from '../../dobovoApartmentsSchema'

export default apartments => {
    const apartmentsData = pathOr([], ['_embedded', 'dobovoMappings'], apartments)
    return { ...normalize(apartmentsData, arrayOfApartments) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/dobovoParsers/dobovoApartments.js